module.exports = __webpack_public_path__ + "img/leaf_left_2.bc5a4225.png";